import React from "react";
import { Provider } from "react-redux";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { ErrorBoundary, Theme } from "@sscs/ui";
import { generateAppRoutes } from "Routes";
import { useGetCSRFTokenQuery } from "Services";
import { store } from "Store/store";
import { getRouteBasename } from "Utils";
import "./utils/yup";

const basename = getRouteBasename();

type GetCSRFTokenProps = {
  children: React.ReactNode;
};

const GetCSRFToken = ({ children }: GetCSRFTokenProps): React.JSX.Element => {
  useGetCSRFTokenQuery();

  return <React.Fragment>{children}</React.Fragment>;
};

const App = (): React.JSX.Element => {
  const router = createBrowserRouter(generateAppRoutes(), {
    basename: basename ? basename : undefined,
  });

  return (
    <Provider store={store}>
      <Theme>
        <ErrorBoundary>
          <GetCSRFToken>
            <RouterProvider router={router} />
          </GetCSRFToken>
        </ErrorBoundary>
      </Theme>
    </Provider>
  );
};

export default App;
